import React, { useState, useEffect, useRef } from "react";
import Bottom from "../../components/Nurse/NurseBottom.js";
import "../Nurse/Nurse.css";
import HeaderText from "../../components/Nurse/NurseHeaderText.js";
import axios from "axios";
import logoutImg from "../../assets/icons/logoutimg.png";
import PatientInfo from "./Menu/PatientInfo/PatientInfo.js";
import RegPatient from "./Menu/RegPatient/RegPatient.js";
import Swal from "sweetalert2";
import { getServerBaseUrl } from "../../utils/portConfig.js";

const initPtInfo = {
  age: "",
  birthDate: "",
  birthDueDate: "",
  chartNo: "",
  emrFamilyHistory: "",
  pastHistory: "",
  patientId: "",
  patientName: "",
  pregnantWeeks: "",
  surgeryType: "",
  isFirstChildbirth: "",
  emrPresentIllness: "",
  naturalDelivery: "",
  cesareanSection: "",
};

const initPtVital = {
  weight: "",
  height: "",
  bmi: "",
  minBloodPressure: "",
  maxBloodPressure: "",
  temperature: "",
  bloodGlucose: "",
  pulseRate: "",
};

const initObHis = {
  patientId: "",
  lastMensDate: "",
};

const Nurse = () => {
  const [activeMenu, setActiveMenu] = useState("환자목록"); // 활성 메뉴 상태
  const [searchData, setSearchData] = useState(null); //검색 결과 정보
  const [birthDate, setBirthDate] = useState(""); //검색 생년월일 형식
  const [patientName, setPatientName] = useState(""); // 환자 이름 상태 추가
  const [selectedPtInfo, setSelectedPtInfo] = useState(initPtInfo); //선택된 환자 정보
  const [selectedPtVital, setSelectedPtVital] = useState(initPtVital); //선택된 환자 바이탈 정보
  const [selectedObHistory, setSelectedObHistory] = useState(initObHis); //선택된 환자의 산과력
  const [editedPatientInfo, setEditedPatientInfo] = useState(initPtInfo); // 변경된 환자 정보
  const [editedPatientVital, setEditedPatientVital] = useState(initPtVital); // 변경된 환자 바이탈 정보
  const [editedObHistory, setEditedObHistory] = useState(initObHis); //변경된 환자의 산과력
  const regPatientRef = useRef(null); // Ref를 사용하여 자식 컴포넌트의 인스턴스에 접근할 수 있도록 함

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1`; // API 서버 URL
  const hospitalId = localStorage.getItem("hospitalId"); //소속 병원 ID;
  const token = localStorage.getItem("token"); // 토큰
  const id = localStorage.getItem("id"); //간호사 숫자 아이디

  // 메뉴 클릭 이벤트 핸들러
  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
  };

  //검색 버튼 클릭 이벤트
  const searchbtnClick = () => {
    let patient_name = patientName.trim() === "" ? null : patientName.trim();
    let birth_date = birthDate.trim() === "" ? null : birthDate.trim();
    getPatientList(patient_name, birth_date);
  };

  //환자 조회
  const getPatientList = async (patient_name, birth_date) => {
    try {
      const params = {
        hospital_id: hospitalId,
        patient_name: patient_name || "",
        birth_date: birth_date || "",
      };

      const response = await axios.get(`${API_SERVER_URL}/checklist/getPatientListForNurse`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSearchData(response.data);
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  //검색된 환자 row 클릭 후 조회
  const handleRowClick = async (patientId) => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/checklist/${patientId}/getPatientInfo`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSelectedPtInfo(response.data.patientInfo);
      setEditedPatientInfo(response.data.patientInfo);

      setSelectedPtVital(response.data.patientVital);
      setEditedPatientVital(response.data.patientVital);

      if (response.data.patientObHistory !== null) {
        setSelectedObHistory(response.data.patientObHistory);
        setEditedObHistory(response.data.patientObHistory);
      } else {
        setSelectedObHistory(initObHis);
        setEditedObHistory(initObHis);
      }

      setActiveMenu("정보입력");
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  //환자 정보 저장
  const savePatientData = async (data) => {
    try {
      const response = await axios.post(`${API_SERVER_URL}/checklist/savePatientInfoByNurse/${hospitalId}/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });

      Swal.fire({
        icon: "success",
        title: "성공",
        text: response.data.message,
        customClass: {
          popup: "custom-swal-popup",
        },
      });

      // 환자 ID를 받아오기 위해 response.data를 사용
      const patientId = response.data.patientId;
      handleRowClick(patientId);
    } catch (error) {
      console.error("Error occurred while saving patient data:", error);
      Swal.fire({
        icon: "error",
        title: "서버 응답 오류",
        text: `서버 응답 오류: ${error.response.status}`,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("userid");
    localStorage.removeItem("id");
    localStorage.removeItem("active");
    localStorage.removeItem("hospitalId");
    window.location.reload();
  };

  const clearData = () => {
    setSelectedPtInfo(initPtInfo);
    setSelectedPtVital(initPtVital);
    setEditedPatientInfo(initPtInfo);
    setEditedPatientVital(initPtVital);
    setEditedObHistory(initObHis);
  };

  //클리어버튼
  const handleClear = () => {
    clearData();
    regPatientRef.current.clearData();
    if (selectedPtInfo.patientId) {
      setActiveMenu("환자목록");
    }
  };

  //저장 버튼
  const handleSave = () => {
    //객체의 값을 가져와 배열로 변환 후 값이 비었는지 확인
    const ptInfoValues = Object.values(editedPatientInfo);
    const isInfoEmpty = ptInfoValues.every((value) => value === "");
    const vitalValues = editedPatientVital ? Object.values(editedPatientVital) : [];
    const isVitalEmpty = !editedPatientVital || vitalValues.every((value) => value === "");
    const obHisValues = Object.values(editedObHistory);
    const isHisEmpty = obHisValues.every((value) => value === "");

    //이름, 생년월일 필수값 확인
    if (editedPatientInfo.patientName === "" || editedPatientInfo.patientName === null) {
      Swal.fire({
        icon: "error",
        title: "필수값 미입력",
        text: "이름을 입력해주세요.",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return false;
    }

    if (editedPatientInfo.birthDate === "" || editedPatientInfo.birthDate === null) {
      Swal.fire({
        icon: "error",
        title: "필수값 미입력",
        text: "생년월일을 입력해주세요.",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return false;
    }

    if (editedPatientInfo.birthDueDate === "" && editedObHistory.lastMensDate === "") {
      Swal.fire({
        icon: "error",
        title: "필수값 미입력",
        text: "마지막생리일 또는 출산예정일을 입력해주세요.",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return false;
    }

    //생년월일, 마지막 생리일, 분만 예정일 날짜 형식 확인
    if (editedPatientInfo.birthDate !== "" && !isValidDateFormat(editedPatientInfo.birthDate)) {
      let formatDate = formatToYYYYMMDD(editedPatientInfo.birthDate);
      if (!isValidDateFormat(formatDate)) {
        Swal.fire({
          icon: "error",
          title: "생년월일의 날짜 형식 오류",
          text: "생년월일의 날짜 형식을 확인해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
        return false;
      } else {
        setEditedPatientInfo((prevState) => ({
          ...prevState,
          birthDate: formatDate,
        }));
      }
    }

    if (editedObHistory.lastMensDate !== "" && !isValidDateFormat(formatToYYYYMMDD(editedObHistory.lastMensDate))) {
      let formatDate = formatToYYYYMMDD(editedObHistory.lastMensDate);
      if (!isValidDateFormat(formatDate)) {
        Swal.fire({
          icon: "error",
          title: "마지막 생리일의 날짜 형식 오류",
          text: "마지막 생리일의 날짜 형식을 확인해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
        return false;
      }
    }

    if (editedPatientInfo.birthDueDate !== "" && !isValidDateFormat(formatToYYYYMMDD(editedPatientInfo.birthDueDate))) {
      let formatDate = formatToYYYYMMDD(editedPatientInfo.birthDueDate);
      if (!isValidDateFormat(formatDate)) {
        Swal.fire({
          icon: "error",
          title: "분만 예정일 날짜 형식 오류",
          text: "분만 예정일의 날짜 형식을 확인해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
        return false;
      }
    }

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
    const dd = String(currentDate.getDate()).padStart(2, "0");

    // formattedDate를 yyyy-mm-dd 형식으로 설정
    const formattedDate = `${yyyy}-${mm}-${dd}`;

    // 생년월일 비교
    if (editedPatientInfo.birthDate > formattedDate) {
      Swal.fire({
        icon: "error",
        title: "날짜 입력 오류",
        text: "생년월일은 오늘 날짜보다 이전이어야 합니다.",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return false;
    }

    // lastMensDate를 yyyy-mm-dd 형식으로 변환
    const lastMensYear = editedObHistory.lastMensDate.slice(0, 4);
    const lastMensMonth = editedObHistory.lastMensDate.slice(4, 6);
    const lastMensDay = editedObHistory.lastMensDate.slice(6, 8);
    const formattedLastMensDate = `${lastMensYear}-${lastMensMonth}-${lastMensDay}`;

    // 마지막 생리일 비교
    if (formattedLastMensDate > formattedDate) {
      Swal.fire({
        icon: "error",
        title: "날짜 입력 오류",
        text: "마지막 생리일은 오늘 날짜보다 이전이어야 합니다.",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return false;
    }

    // 자연분만 및 제왕절개 값 검증
    if (editedPatientInfo.naturalDelivery === null || editedPatientInfo.naturalDelivery === "") {
      editedPatientInfo.naturalDelivery = 0;
    }

    if (editedPatientInfo.cesareanSection === null || editedPatientInfo.cesareanSection === "") {
      editedPatientInfo.cesareanSection = 0;
    }

    if (!isInfoEmpty) {
      const ptInfo = {
        patientInfo: editedPatientInfo,
        patientVital: isVitalEmpty ? null : editedPatientVital,
        patientObHistory: isHisEmpty ? null : editedObHistory,
      };

      if (!ptInfo.patientInfo.patientId) {
        checkExistingPatient(ptInfo);
      } else {
        savePatientData(ptInfo);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "환자 정보 미입력",
        text: "환자 정보를 입력해주세요.",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  // 재진 여부 확인
  const checkExistingPatient = async (ptInfo) => {
    try {
      const params = {
        hospital_id: hospitalId,
        patient_name: ptInfo.patientInfo.patientName || "",
        birth_date: ptInfo.patientInfo.birthDate || "",
      };

      const response = await axios.get(`${API_SERVER_URL}/checklist/getPatientListForNurse`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.length === 0) {
        savePatientData(ptInfo);
      } else {
        Swal.fire({
          title: "저장 불가",
          html: "초진 환자로 저장할 수 없습니다.<br>이미 환자 정보가 있습니다.",
          icon: "error",
          confirmButtonText: "확인",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "오류",
        text: "환자 정보 확인 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  const isValidDateFormat = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD 형식을 나타내는 정규식입니다.

    if (!regex.test(dateString)) {
      return false; // 형식이 맞지 않으면 유효하지 않은 날짜 형식으로 간주합니다.
    }

    const year = parseInt(dateString.substr(0, 4), 10);
    const month = parseInt(dateString.substr(5, 2), 10);
    const day = parseInt(dateString.substr(8, 2), 10);

    // 날짜 객체를 생성하여 유효성을 확인합니다.
    const dateObject = new Date(year, month - 1, day); // month는 0부터 시작하므로 -1 처리합니다.
    const isValidDate = dateObject.getFullYear() === year && dateObject.getMonth() === month - 1 && dateObject.getDate() === day;

    return isValidDate;
  };

  const formatToYYYYMMDD = (dateString) => {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}-${month}-${day}`;
  };

  //환자 정보 Change Event
  const handlePatientInfoChange = (name, value) => {
    setEditedPatientInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //환자 바이탈 Change Event
  const handlePatientVitalChange = (name, value) => {
    setEditedPatientVital((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //환자 산과력 Change Event
  const handlePatientOHChange = (name, value) => {
    setEditedObHistory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //환자 이름 입력 핸들러
  const handlePatientNameChange = (e) => {
    setPatientName(e.target.value);
  };

  // 검색창 날짜를 YYYY-MM-DD 형식으로 변경함
  const handleDateFormat = (e) => {
    const inputValue = e.target.value;
    // Remove non-numeric characters
    const numericValue = inputValue.replace(/\D/g, "");

    let formattedValue = "";
    if (numericValue.length <= 4) {
      // Only year part
      formattedValue = numericValue;
    } else if (numericValue.length <= 6) {
      // Year and month
      formattedValue = `${numericValue.substring(0, 4)}-${numericValue.substring(4)}`;
    } else {
      // Year, month, and day
      formattedValue = `${numericValue.substring(0, 4)}-${numericValue.substring(4, 6)}-${numericValue.substring(6, 8)}`;
    }

    setBirthDate(formattedValue);
  };

  // 엔터 키 이벤트 핸들러
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 기본 동작 방지
      searchbtnClick();
    }
  };

  // 데이터 전처리를 위한 useEffect
  useEffect(() => {
    // obhistory의 마지막생리일과 tb_patient의 출산 예정일을, YYYY-MM-DD에서 YYYYMMDD로 변경
    if (editedObHistory.lastMensDate !== "") {
      const lastmensDateParts = editedObHistory.lastMensDate.split("-");
      if (lastmensDateParts.length === 3) {
        const year = lastmensDateParts[0];
        const month = lastmensDateParts[1];
        const day = lastmensDateParts[2];
        const formattedDate = year + month.padStart(2, "0") + day.padStart(2, "0");
        setEditedObHistory((prevState) => ({
          ...prevState,
          lastMensDate: formattedDate,
        }));
      }
    }

    if (editedPatientInfo.birthDueDate !== "") {
      const birthDueDateparts = editedPatientInfo.birthDueDate.split("-");
      if (birthDueDateparts.length === 3) {
        const year = birthDueDateparts[0];
        const month = birthDueDateparts[1];
        const day = birthDueDateparts[2];
        const formattedDate = year + month.padStart(2, "0") + day.padStart(2, "0");
        setEditedPatientInfo((prevState) => ({
          ...prevState,
          birthDueDate: formattedDate,
        }));
      }
    }
  }, [editedObHistory, editedPatientInfo]);

  return (
    <>
      <HeaderText />
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="patient-info-searchbar">
          {activeMenu === "정보입력" ? (
            <div className="nurse-btn-div">
              <button type="button" className="nurse-clear-btn" onClick={handleClear}>
                {selectedPtInfo.patientId ? "닫기" : "초기화"}
              </button>
              <button type="button" className="nurse-save-btn" onClick={handleSave}>
                저장
              </button>
            </div>
          ) : (
            <>
              <div className="row nurse-row-align">
                <input className="patient-name-input" id="patientName" placeholder="환자명" value={patientName} onChange={handlePatientNameChange} onKeyDown={handleKeyPress} />
                <input className="birth-date-input" id="patientBirth" placeholder="생년월일" value={birthDate} onChange={handleDateFormat} onKeyDown={handleKeyPress} />
                <div className="nurse-search-btn-div">
                  <button type="button" className="search_pt_btn" onClick={searchbtnClick}>
                    검색
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
        <img src={logoutImg} alt="로그아웃" className="logout-button" onClick={handleLogout} style={{ marginRight: "10px" }} />
      </div>
      <div className="nurse-content-container">
        {activeMenu === "환자목록" && <PatientInfo searchData={searchData} handleRowClick={handleRowClick} />}
        {activeMenu === "정보입력" && (
          <RegPatient
            patientId={selectedPtInfo?.patientId}
            ref={regPatientRef}
            patientVital={editedPatientVital}
            patientInfo={editedPatientInfo}
            patientObHistory={editedObHistory}
            onPatientInfoChange={handlePatientInfoChange}
            onPatientVSChange={handlePatientVitalChange}
            onPatientObHistoryChange={handlePatientOHChange}
          />
        )}
      </div>
      <Bottom activeItem={activeMenu} onMenuClick={handleMenuClick} />
    </>
  );
};

export default Nurse;
